export default __webpack_public_path__ + "static/media/instructions_2.68470f3b.png";